export enum TypesWPContent {
  GET_WP_CONTENT_REQUEST = 'WPContent.GET_WP_CONTENT_REQUEST',
  GET_WP_CONTENT_SUCCESS = 'WPContent.GET_WP_CONTENT_SUCCESS',
  GET_WP_CONTENT_FAILED = 'WPContent.GET_WP_CONTENT_FAILED',

  OPEN_WP_MODAL = 'WPContent.OPEN_WP_MODAL',
  CLOSE_WP_MODAL = 'WPContent.CLOSE_WP_MODAL'
}
